module.exports = __webpack_public_path__ + "static/media/tablet-active.feb9e7bf.svg";